module.exports = __webpack_public_path__ + "assets/img/page5-design-side-nav-collapse-56a1d45c.png";